import { render } from "./ResponseMessageList.vue?vue&type=template&id=1350ada4"
import script from "./ResponseMessageList.vue?vue&type=script&lang=js"
export * from "./ResponseMessageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__